import React from 'react';
import useTranslate from '../../../../../../../customHooks/useTranslate';

interface PositioningSummaryProps {
    weLead: number;
    parity: number;
    gaps: number;
}
const PositioningSummary = ({
    weLead,
    parity,
    gaps,
}: PositioningSummaryProps) => {
    const translate = useTranslate();
    return (
        <div className='flex flex-between gap-10'>
            <div className='flex-column gap-5'>
                <p className='stat-position__value --lead'>{weLead}</p>
                <p>{translate('we_lead')}</p>
            </div>
            <div className='flex-column gap-5'>
                <p className='stat-position__value --parity'>{parity}</p>
                <p>{translate('parity')}</p>
            </div>
            <div className='flex-column gap-5'>
                <p className='stat-position__value --gap'>{gaps}</p>
                <p>{translate('gaps')}</p>
            </div>
        </div>
    );
};

export default PositioningSummary;
